import styled from "styled-components";

export const TitleText = styled.p`
	font-family: "Bebas Neue";
	font-size: clamp(50px, 15vw, 70px);
	margin: 0px auto;
	padding: 20px 0px;
	position: relative;
`;
